"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEFT_SIDEBAR_TYPE_SCROLLABLE = exports.LEFT_SIDEBAR_TYPE_FIXED = exports.LEFT_SIDEBAR_TYPE_CONDENSED = exports.LEFT_SIDEBAR_THEME_LIGHT = exports.LEFT_SIDEBAR_THEME_DEFAULT = exports.LEFT_SIDEBAR_THEME_DARK = exports.LAYOUT_WIDTH_FLUID = exports.LAYOUT_WIDTH_BOXED = exports.LAYOUT_VERTICAL = exports.LAYOUT_HORIZONTAL = exports.LAYOUT_DETACHED = void 0;
var LAYOUT_VERTICAL = "vertical";
exports.LAYOUT_VERTICAL = LAYOUT_VERTICAL;
var LAYOUT_HORIZONTAL = "topnav";
exports.LAYOUT_HORIZONTAL = LAYOUT_HORIZONTAL;
var LAYOUT_DETACHED = "detached";
exports.LAYOUT_DETACHED = LAYOUT_DETACHED;
var LAYOUT_WIDTH_FLUID = "fluid";
exports.LAYOUT_WIDTH_FLUID = LAYOUT_WIDTH_FLUID;
var LAYOUT_WIDTH_BOXED = "boxed";
exports.LAYOUT_WIDTH_BOXED = LAYOUT_WIDTH_BOXED;
var LEFT_SIDEBAR_THEME_DEFAULT = "default";
exports.LEFT_SIDEBAR_THEME_DEFAULT = LEFT_SIDEBAR_THEME_DEFAULT;
var LEFT_SIDEBAR_THEME_LIGHT = "light";
exports.LEFT_SIDEBAR_THEME_LIGHT = LEFT_SIDEBAR_THEME_LIGHT;
var LEFT_SIDEBAR_THEME_DARK = "dark";
exports.LEFT_SIDEBAR_THEME_DARK = LEFT_SIDEBAR_THEME_DARK;
var LEFT_SIDEBAR_TYPE_FIXED = "fixed";
exports.LEFT_SIDEBAR_TYPE_FIXED = LEFT_SIDEBAR_TYPE_FIXED;
var LEFT_SIDEBAR_TYPE_CONDENSED = "condensed";
exports.LEFT_SIDEBAR_TYPE_CONDENSED = LEFT_SIDEBAR_TYPE_CONDENSED;
var LEFT_SIDEBAR_TYPE_SCROLLABLE = "scrollable";
exports.LEFT_SIDEBAR_TYPE_SCROLLABLE = LEFT_SIDEBAR_TYPE_SCROLLABLE;